import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
// import { FiCheckCircle } from "react-icons/fi"
import { Link } from "gatsby"
import Image from "gatsby-plugin-sanity-image"
import PortableText from "../components/PortableText"

const BigNewsBox = ({
  themeColor,
  title,
  category,
  categoryLink,
  subcategory,
  publishDay,
  link,
  text,
  image,
}) => {
  var themeBgColor = "text-fb-blue"
  var themeTextColor = "text-fb-blue"
  var themeTextGroupHover = "group-hover:text-fb-blue"

  switch (themeColor) {
    case "fb-green": {
      themeBgColor = "bg-fb-green"
      themeTextColor = "text-fb-green"
      themeTextGroupHover = "group-hover:text-fb-green"
      break
    }
    case "fb-turquoise": {
      themeBgColor = "bg-fb-turquoise"
      themeTextColor = "text-fb-turquoise"
      themeTextGroupHover = "group-hover:text-fb-turquoise"
      break
    }
    case "fb-gray": {
      themeBgColor = "bg-fb-gray"
      themeTextColor = "text-fb-gray"
      themeTextGroupHover = "group-hover:text-fb-gray"
      break
    }
    case "fb-red": {
      themeBgColor = "bg-fb-red"
      themeTextColor = "text-fb-red"
      themeTextGroupHover = "group-hover:text-fb-red"
      break
    }
    case "fb-violet": {
      themeBgColor = "bg-fb-violet"
      themeTextColor = "text-fb-violet"
      themeTextGroupHover = "group-hover:text-fb-violet"
      break
    }
    default: {
      themeBgColor = "bg-fb-blue"
      themeTextColor = "text-fb-blue"
      themeTextGroupHover = "group-hover:text-fb-blue"
      break
    }
  }
  return (
    <div className="bg-fb-blue bg-opacity-10">
      <Link
        to={`/${categoryLink}/${link}`}
        className={`${themeTextColor} link`}
      >
        <div className="group relative h-80 mb-5">
          <Image
            // pass asset, hotspot, and crop fields
            {...image}
            // tell Sanity how large to make the image (does not set any CSS)
            width={300}
            height={200}
            alt={image.alt || "Finanzas de Bolsillo"}
            className="rounded"
            // style it how you want it
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />

          <div className="absolute top-0 bg-white bg-opacity-80 w-80 h-full">
            <CategoryBar className={`${themeBgColor} category-bar`}>
              {category}
            </CategoryBar>

            {/* <h2 className={`${themeTextColor} article-name`}>{title}</h2> */}
            <h2
              className={`${themeTextGroupHover} article-name group-hover:underline`}
            >
              {title}
            </h2>
            <h3 className={`${themeTextColor} subheader pl-5`}>
              {subcategory}
            </h3>
          </div>
        </div>
      </Link>
      <div className="px-5 h-80 mb-5">
        {/* <div className="flex py-2">
          <FiCheckCircle />
          <small className="pl-3">{publishDay}</small>
        </div> */}
        <PortableText textData={text} />
        <div className="text-right pt-20">
          <Link
            to={`/${categoryLink}/${link}`}
            className={`${themeTextColor} link`}
          >
            Читать дальше...
          </Link>
        </div>
      </div>
    </div>
  )
}

BigNewsBox.prototype = {
  mainPicture: PropTypes.string,
  themeColor: PropTypes.string,
}
BigNewsBox.defaultProps = {
  mainPicture: `https://source.unsplash.com/random`,
  themeColor: `fb-blue`,
}

const CategoryBar = styled.div`
  position: absolute;
  top: 10px;
  left: -10px;
  width: 100%;
  height: 60px;
`

export default BigNewsBox
